import React from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";

const SidebarNavItem = ({ item, isActive, onClick, collapsed = false }) => {
  const tooltipId = `nav-tooltip-${item.name.toLowerCase().replace(/\s+/g, '-')}`;
  
  return (
    <>
      <Link
        to={item.href}
        onClick={onClick}
        className={`group flex items-center text-sm font-medium rounded-lg transition-colors duration-150 ${
          collapsed ? 'justify-center px-2 py-2.5' : 'px-3 py-2.5'
        } ${
          isActive
            ? "bg-theme-main bg-opacity-80 text-theme-text shadow-sm"
            : "text-theme-text opacity-70 hover:opacity-100 hover:bg-black hover:bg-opacity-10"
        }`}
        data-tooltip-id={collapsed ? tooltipId : undefined}
        data-tooltip-content={collapsed ? item.name : undefined}
      >
        <span
          className={`flex-shrink-0 ${
            isActive ? "text-theme-primary" : "text-theme-text opacity-60 group-hover:opacity-100"
          }`}
        >
          {item.icon}
        </span>
        {!collapsed && <span className="ml-2">{item.name}</span>}
      </Link>
      {collapsed && <Tooltip id={tooltipId} place="right" className="z-50" />}
    </>
  );
};

export default SidebarNavItem;
